import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as reducers from '../../../store/reducers';
import { ForgotPasswordActions } from '../../../store/actions';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  forgotPasswordLoading$: Observable<boolean>;
  forgotPasswordError$: Observable<any>;
  success$: Observable<boolean>;
  submitted = false;

  constructor(
    private store: Store<reducers.State>,
  ) {
    this.forgotPasswordError$ = this.store.pipe(select(reducers.getForgotPasswordErrorMessage));
    this.forgotPasswordLoading$ = this.store.pipe(select(reducers.getForgotPasswordLoading));
    this.success$ = this.store.pipe(select(reducers.getForgotPasswordSuccess));
  }

  get f() { return this.forgotPasswordForm.controls; }

  ngOnInit() {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.email, Validators.required]),
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    } else {
        this.store.dispatch(ForgotPasswordActions.forgotPassword({email: this.forgotPasswordForm.value.email}));
    }
  }
}
